import React, { Component } from 'react';

import {AuthContext} from "../../authContext";
import CategoryDisplayContainer from "./CategoryDisplayContainer";
import CategoryTitle from "./CategoryTitle";
import HelpArticleIcon from "../shared/utilities/HelpArticleIcon";
import { helpArticlePath } from "../../configuration";
import HelpResultCard from "./HelpResultCard";
import HelpResultCardContainer from "./HelpResultCardContainer";
import HelpResultIcon from "./HelpResultIcon";

class CategoryDisplay extends Component {
  static contextType = AuthContext;
  render() {
    // console.log(this.props);
    return (
      <CategoryDisplayContainer gettingStarted={this.props.gettingStarted}>
        <CategoryTitle>{this.props.title}</CategoryTitle>
        <HelpResultCardContainer>
          {this.props.articles.map(article => {
            return (
              <HelpResultCard key={article.id} onClick={e => {e.preventDefault(); this.context.navigate(`../../${helpArticlePath}${article.id}`)}}>
                <HelpResultIcon>
                  <HelpArticleIcon title={article.title} reference={article.icon} />
                </HelpResultIcon>
                <div>
                  {article.title}
                </div>
              </HelpResultCard>
            )
          })}
        </HelpResultCardContainer>
      </CategoryDisplayContainer>
    );
  }
}

export default CategoryDisplay;
